import React, { Fragment } from "react";

import type { Props } from "../types/Media";

import { ImageMedia } from "./ImageMedia/ImageMedia";
import { VideoMedia } from "./VideoMedia/VideoMedia";
import { PdfMedia } from "./PdfMedia/PdfMedia";

export const Media: React.FC<Props> = (props) => {
  const { className, htmlElement = "div", resource } = props;

  const isVideo =
    typeof resource === "object" && resource?.mimeType?.includes("video");
  const Tag = htmlElement || Fragment;

  const isPDF =
    typeof resource === "object" && resource?.mimeType?.includes("pdf");

  return (
    <Tag
      {...(htmlElement !== null
        ? {
            className,
          }
        : {})}
    >
      {isVideo && <VideoMedia {...props} />}
      {isPDF && <PdfMedia {...props} />}
      {!isPDF && !isVideo && <ImageMedia {...props} />}
    </Tag>
  );
};
